export default "__VITE_ASSET__045cb40b__"